/**
 * @file Maps backend wall AI chat `loading_message_key` values to localized status text.
 * Keys match Ruby `LlmTools::*#loading_message_key` (Phase 1 allowlist + default `thinking`).
 */
import { __ } from '@@/bits/intl'

enum LoadingMessageKey {
  THINKING = 'thinking',
  CREATING_POSTS = 'creating_posts',
  SEARCHING_THE_WEB = 'searching_the_web',
  EXPORTING_BOARD = 'exporting_board',
  EXPORTING_WHITEBOARD = 'exporting_whiteboard',
  ANALYZING_ATTACHMENTS = 'analyzing_attachments',
  GENERATING_INSIGHTS = 'generating_insights',
  GRADING_POSTS = 'grading_posts',
  SYNCING_GRADES = 'syncing_grades',
  SEARCHING_PADLETS = 'searching_padlets',
  REMAKING_PADLET = 'remaking_padlet',
  RESTORING_CONTENT = 'restoring_content',
  INVITING_MEMBERS = 'inviting_members',
  SENDING_INVITATIONS = 'sending_invitations',
}

const MESSAGES: Record<LoadingMessageKey, string> = {
  [LoadingMessageKey.THINKING]: __('Thinking…'),
  [LoadingMessageKey.CREATING_POSTS]: __('Creating posts…'),
  [LoadingMessageKey.SEARCHING_THE_WEB]: __('Searching the web…'),
  [LoadingMessageKey.EXPORTING_BOARD]: __('Exporting board…'),
  [LoadingMessageKey.EXPORTING_WHITEBOARD]: __('Exporting sandbox…'),
  [LoadingMessageKey.ANALYZING_ATTACHMENTS]: __('Analyzing attachments…'),
  [LoadingMessageKey.GENERATING_INSIGHTS]: __('Generating insights…'),
  [LoadingMessageKey.GRADING_POSTS]: __('Grading posts…'),
  [LoadingMessageKey.SYNCING_GRADES]: __('Syncing grades…'),
  [LoadingMessageKey.SEARCHING_PADLETS]: __('Searching padlets…'),
  [LoadingMessageKey.REMAKING_PADLET]: __('Remaking padlet…'),
  [LoadingMessageKey.RESTORING_CONTENT]: __('Restoring content…'),
  [LoadingMessageKey.INVITING_MEMBERS]: __('Inviting members…'),
  [LoadingMessageKey.SENDING_INVITATIONS]: __('Sending invitations…'),
}

const DEFAULT_LOADING_MESSAGE_KEY = LoadingMessageKey.THINKING
const DEFAULT_LOADING_MESSAGE = MESSAGES[DEFAULT_LOADING_MESSAGE_KEY]

const resolveSurfaceAiChatLoadingMessage = (key: string): string => {
  if (key in MESSAGES) {
    return MESSAGES[key as LoadingMessageKey]
  }
  return DEFAULT_LOADING_MESSAGE
}

export { DEFAULT_LOADING_MESSAGE_KEY, DEFAULT_LOADING_MESSAGE, LoadingMessageKey, resolveSurfaceAiChatLoadingMessage }
